import Vue from 'vue';
import Cookies from 'js-cookie';

export const UserSession = Vue.observable({
  token: Cookies.get("_console_token")
});

export const UserSessionMod = {
  setToken(token){
    UserSession.token = token;
  }
};
